import { UserModel, LevelModel, CompanyModel } from '@/types';

export interface AuthServiceLoginBody {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface AuthServiceLoginResult {
    user: UserModel;
    level: LevelModel;
    company: CompanyModel;
    jwt: string | null;
    jwtTemp: string | null;
}

export interface AuthServiceTwoFaSetupResult {
    secretBase32: string;
    otpAuthUrl: string;
}

export interface AuthServiceTwoFaVerifyBody {
    code: string | number;
    remember?: boolean;
}
